"use client";

import { motion, AnimatePresence } from "framer-motion";

interface MindalooAutonomousPanelProps {
  open: boolean;
  onClose: () => void;
  onEnable?: () => void;
}

export default function MindalooAutonomousPanel({
  open,
  onClose,
  onEnable,
}: MindalooAutonomousPanelProps) {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[1490] bg-black/40 backdrop-blur-md"
            onClick={onClose}
          />
          <motion.aside
            initial={{ x: 360 }}
            animate={{ x: 0 }}
            exit={{ x: 360 }}
            transition={{ type: "spring", stiffness: 400, damping: 35 }}
            className="fixed right-0 top-0 bottom-0 w-[min(340px,90vw)] z-[1500] karma-glass karma-neon-ring p-5"
          >
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-sm tracking-[0.15em] uppercase font-light">Autonomous Mode</h3>
              <button type="button" onClick={onClose}>
                ×
              </button>
            </div>
            <p className="text-sm opacity-60 leading-relaxed mb-6">
              Parallel multi-agent loops with Karma AC Core. Atlas routes context; OpenClaw executes
              when sovereign tier is active.
            </p>
            <button
              type="button"
              onClick={() => {
                onEnable?.();
                onClose();
              }}
              className="w-full py-3 rounded-xl text-sm font-medium bg-[#C1A2FF]/20 border border-[#C1A2FF]/40 text-[#C1A2FF]"
            >
              Arm autonomous loop
            </button>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
